import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MaskedInput from 'react-input-mask';
import { Row, Col, Card, Form, Input, Button, Alert, notification, Select } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import { storage } from 'helpers';
import definitionService from 'services/definition.service';
import branchService from 'services/branch.service';
import merchService from 'services/merch.service';

const { Option } = Select;

const BranchAdd = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [selectedMerch] = useState(storage.get('selectedMerch').number);
  const [token] = useState(storage.get('pm-token'));
  const [cities, setCities] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [neighborhoods, setNeighborhoods] = useState([]);
  const [types, setTypes] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [setLoading] = useState(false);
  const [error] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      await getCities();
      await getMerchant();
    };
    fetchData();
  }, []);

  const getMerchant = async () => {
    try {
      const response = await merchService.getMerchant(selectedMerch);
      setTypes(response.payload);
      // eslint-disable-next-line
    } catch (err) {
      notification.error({
        message: 'Hata',
        description: 'İş yeri bilgileri alınamadı.',
      });
    }
  };

  const getCities = async () => {
    try {
      const response = await definitionService.getDefinition('city');
      setCities(response.payload);
      // eslint-disable-next-line
    } catch (err) {
      notification.error({
        message: 'Hata',
        description: 'Şehir bilgileri alınamadı.',
      });
    }
  };

  const getDistricts = async (cityId) => {
    try {
      const response = await definitionService.getDefinition('district', { cityId });
      setDistricts(response.payload);
      form.resetFields(['DistrictId']);
      // eslint-disable-next-line
    } catch (err) {
      notification.error({
        message: 'Hata',
        description: 'İlçe bilgileri alınamadı.',
      });
    }
  };

  const getNeighborhoods = async (districtId) => {
    try {
      const response = await definitionService.getDefinition('neighborhood', { districtId });
      setNeighborhoods(response.payload);
      form.resetFields(['NeighborhoodId']);
      // eslint-disable-next-line
    } catch (err) {
      notification.error({
        message: 'Hata',
        description: 'Mahalle bilgileri alınamadı.',
      });
    }
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    setSubmitting(true);
    const gsm = values.Gsm.replace(/[^\d\\+]/g, '');
    const { Gsm, ...clonedObject } = values;
    const newValues = {
      ...clonedObject,
      Gsm: gsm,
      token,
    };

    try {
      await branchService.addBranch(selectedMerch, newValues);
      notification.success({
        message: 'İşlem Başarılı',
        description: 'Şube eklendi!',
      });
      setLoading(false);
      setSubmitting(false);
      navigate(-1);
    } catch (err) {
      notification.error({
        message: 'İşlem Başarısız',
        description: err.message || 'Bir hata oluştu.',
      });
      setLoading(false);
      setSubmitting(false);
    }
  };

  return (
    <PageContainer title="Yeni Şube Başvurusu" onBack={() => navigate(-1)}>
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        {error && (
          <Form.Item>
            <Alert message={error} type="error" showIcon />
          </Form.Item>
        )}
        <Row gutter={[20, 20]}>
          <Col span={12}>
            <Card type="inner" title="Şube Bilgileri">
              <Form.Item
                name="BranchTitle"
                label="Şube Adı"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Input className="input__default" placeholder="Şube Adı" />
              </Form.Item>
              <Form.Item
                name="BranchCategoryList"
                label="Kategori"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Select mode="multiple" style={{ width: '100%' }} placeholder="Kategori Seçiniz">
                  {types?.map((type) => (
                    <Option key={type?.MerchantTypeId} value={type?.MerchantTypeId}>
                      {type.Name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="BranchContactPerson"
                label="Yetkili Kişi"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Input className="input__default" placeholder="Yetkili Kişi" />
              </Form.Item>
            </Card>
          </Col>
          <Col span={12}>
            <Card type="inner" title="İletişim Bilgileri">
              <Form.Item
                name="Gsm"
                label="İletişim No"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <MaskedInput mask="(999) 999-99-99">
                  {() => <Input className="input__default" placeholder="İletişim No" />}
                </MaskedInput>
              </Form.Item>
              <Form.Item
                name="Email"
                label="Email"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Input className="input__default" placeholder="Email" />
              </Form.Item>
            </Card>
          </Col>
          <Col span={24}>
            <Card type="inner" title="Adres Bilgileri">
              <Form.Item
                name="Address"
                label="Açık Adres"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Input.TextArea className="input__default" placeholder="Açık Adres" />
              </Form.Item>
              <Form.Item
                name="CityId"
                label="İl"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="İl Seçiniz"
                  onChange={(c) => getDistricts(c)}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {cities?.map((c) => (
                    <Option key={c.CityId} value={c.CityId}>
                      {c.Name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="DistrictId"
                label="İlçe"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="İlçe Seçiniz"
                  onChange={(d) => getNeighborhoods(d)}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {districts?.map((d) => (
                    <Option key={d.DistrictId} value={d.DistrictId}>
                      {d.Name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="NeighborhoodId"
                label="Mahalle"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="Mahalle Seçiniz"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {neighborhoods?.map((n) => (
                    <Option key={n.NeighborhoodId} value={n.NeighborhoodId}>
                      {n.Name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Card>
          </Col>
        </Row>
        <Form.Item className="text-align-right">
          <Button
            className="button button__fill"
            type="primary"
            htmlType="submit"
            disabled={submitting}
            loading={submitting}
          >
            Kaydet
          </Button>
        </Form.Item>
      </Form>
    </PageContainer>
  );
};

export default BranchAdd;
